import { Users, Sparkles } from 'lucide-react';
import { Card } from '../ui/Card';

const Investors = () => {
  const investors = [
    { name: 'Rohit Mehra', role: 'Angel Investor • Fintech' },
    { name: 'Meera Kapoor', role: 'VC • SaaS' },
    { name: 'Arjun Singh', role: 'Corporate Investor • Healthtech' },
    { name: 'Priya Patel', role: 'Founder • Growth' }
  ];

  return (
    <section id="investors" className="py-10 px-6 bg-primary text-textPrimary">
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Meet the Sharks</h2>
          <p className="text-xl text-textMuted">
            Confirmed investors & mentors
          </p>
        </div>

        {/* Investor Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {investors.map((investor, index) => (
            <Card
              key={index}
              className="
                p-6 text-center 
                bg-tertiary 
                border border-borderLight 
                rounded-2xl 
                shadow-card 
                hover:bg-secondary/70 
                hover:shadow-xl 
                transition-all
                group
              "
              hover
            >
              {/* Avatar Icon */}
              <div
                className="
                  w-24 h-24 
                  rounded-full 
                  mx-auto mb-4 
                  flex items-center justify-center 
                  bg-blueTint 
                  text-bluePrimary
                  transition-colors
                  group-hover:text-white
                "
              >
                <Users className="w-10 h-10 group-hover:text-white transition-colors" />
              </div>

              {/* Name */}
              <h3
                className="
                  text-lg font-bold 
                  text-black 
                  mb-1
                  transition-colors
                  group-hover:text-white
                "
              >
                {investor.name}
              </h3>

              {/* Role */}
              <p
                className="
                  text-sm 
                  text-textMuted
                  transition-colors
                  group-hover:text-white
                "
              >
                {investor.role}
              </p>
            </Card>
          ))}
        </div>

        {/* +15 Investors Badge */}
        <div className="mt-12 flex justify-center">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-bluePrimary/10 to-bluePrimary/5 border border-bluePrimary/30 px-5 py-2.5 rounded-full backdrop-blur-sm">
            <Sparkles className="w-4 h-4 text-bluePrimary" />
            <span className="text-bluePrimary font-medium text-sm tracking-wide">
              +15 Investors
            </span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Investors;